// Mock data for wedding photography portfolio

// Hero Slider Images - For the first section
export const heroSliderImages = [
  'https://images.unsplash.com/photo-1604017011826-d3b4c23f8914',
  'https://images.unsplash.com/photo-1573676048035-9c2a72b6a12a',
  'https://images.unsplash.com/photo-1583939003579-730e3918a45a',
  'https://images.unsplash.com/photo-1591604466107-ec97de577aff',
  'https://images.unsplash.com/photo-1507915977619-6ccfe8003ae6',
  'https://images.pexels.com/photos/34793910/pexels-photo-34793910.jpeg',
  'https://images.pexels.com/photos/14339090/pexels-photo-14339090.jpeg',
  'https://images.unsplash.com/flagged/photo-1552981941-424aac2b4311'
];

export const albums = [
  {
    id: 'album1',
    title: 'Elegant Garden Wedding',
    coverImage: 'https://images.unsplash.com/photo-1573676048035-9c2a72b6a12a',
    date: 'June 15, 2024',
    location: 'Sunset Gardens, California',
    photoCount: 45,
    images: [
      'https://images.unsplash.com/photo-1573676048035-9c2a72b6a12a',
      'https://images.unsplash.com/flagged/photo-1552981941-424aac2b4311',
      'https://images.unsplash.com/photo-1533091090875-1ff4acc497dd',
      'https://images.unsplash.com/photo-1599462616558-2b75fd26a283',
      'https://images.unsplash.com/photo-1621801306185-8c0ccf9c8eb8',
      'https://images.unsplash.com/photo-1630526720753-aa4e71acf67d',
      'https://images.pexels.com/photos/36154486/pexels-photo-36154486.jpeg',
    ]
  },
  {
    id: 'album2',
    title: 'Romantic Ceremony',
    coverImage: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a',
    date: 'July 8, 2024',
    location: 'Rose Chapel, New York',
    photoCount: 38,
    images: [
      'https://images.unsplash.com/photo-1583939003579-730e3918a45a',
      'https://images.unsplash.com/photo-1583939411023-14783179e581',
      'https://images.unsplash.com/photo-1647296020388-787fdae78e3c',
      'https://images.unsplash.com/photo-1723832348105-2e69f948135a',
      'https://images.unsplash.com/photo-1714972383570-44ddc9738355',
    ]
  },
  {
    id: 'album3',
    title: 'Grand Ballroom Celebration',
    coverImage: 'https://images.unsplash.com/photo-1723832347953-83c28e2d4dd2',
    date: 'August 20, 2024',
    location: 'Crystal Ballroom, Chicago',
    photoCount: 52,
    images: [
      'https://images.unsplash.com/photo-1723832347953-83c28e2d4dd2',
      'https://images.pexels.com/photos/34793910/pexels-photo-34793910.jpeg',
      'https://images.unsplash.com/photo-1723832348105-2e69f948135a',
      'https://images.unsplash.com/photo-1647296020388-787fdae78e3c',
    ]
  },
  {
    id: 'album4',
    title: 'Classic Love Story',
    coverImage: 'https://images.unsplash.com/photo-1591604466107-ec97de577aff',
    date: 'September 5, 2024',
    location: 'Heritage Estate, Boston',
    photoCount: 41,
    images: [
      'https://images.unsplash.com/photo-1591604466107-ec97de577aff',
      'https://images.unsplash.com/photo-1604017011826-d3b4c23f8914',
      'https://images.pexels.com/photos/14339090/pexels-photo-14339090.jpeg',
      'https://images.pexels.com/photos/14339118/pexels-photo-14339118.jpeg',
    ]
  },
  {
    id: 'album5',
    title: 'Autumn Romance',
    coverImage: 'https://images.unsplash.com/photo-1507915977619-6ccfe8003ae6',
    date: 'October 12, 2024',
    location: 'Maple Valley, Vermont',
    photoCount: 33,
    images: [
      'https://images.unsplash.com/photo-1507915977619-6ccfe8003ae6',
      'https://images.unsplash.com/photo-1630526720753-aa4e71acf67d',
      'https://images.pexels.com/photos/36154486/pexels-photo-36154486.jpeg',
    ]
  },
  {
    id: 'album6',
    title: 'Joyful Reception',
    coverImage: 'https://images.unsplash.com/photo-1527529482837-4698179dc6ce',
    date: 'November 3, 2024',
    location: 'Seaside Resort, Miami',
    photoCount: 47,
    images: [
      'https://images.unsplash.com/photo-1527529482837-4698179dc6ce',
      'https://images.unsplash.com/photo-1714972383570-44ddc9738355',
      'https://images.unsplash.com/photo-1583939411023-14783179e581',
    ]
  },
  {
    id: 'album7',
    title: 'Elegant Evening',
    coverImage: 'https://images.pexels.com/photos/34793910/pexels-photo-34793910.jpeg',
    date: 'December 1, 2024',
    location: 'Downtown Grand Hotel',
    photoCount: 36,
    images: [
      'https://images.pexels.com/photos/34793910/pexels-photo-34793910.jpeg',
      'https://images.unsplash.com/photo-1723832347953-83c28e2d4dd2',
    ]
  },
  {
    id: 'album8',
    title: 'Graceful Moments',
    coverImage: 'https://images.pexels.com/photos/14339090/pexels-photo-14339090.jpeg',
    date: 'January 18, 2025',
    photoCount: 39,
    location: 'Blossom Gardens, Portland',
    images: [
      'https://images.pexels.com/photos/14339090/pexels-photo-14339090.jpeg',
      'https://images.unsplash.com/photo-1677691257001-8bfd91e288ff',
      'https://images.unsplash.com/photo-1677691257237-3294c7fd18a5',
      'https://images.unsplash.com/photo-1677691256999-45d69a11b197',
      'https://images.unsplash.com/photo-1610173826014-d131b02d69ca',
    ]
  }
];

// All images for mosaic gallery with updated categories
export const allGalleryImages = [
  {
    id: 'img1',
    url: 'https://images.unsplash.com/photo-1604017011826-d3b4c23f8914',
    category: 'couple',
    albumId: 'album4'
  },
  {
    id: 'img2',
    url: 'https://images.unsplash.com/photo-1573676048035-9c2a72b6a12a',
    category: 'couple',
    albumId: 'album1'
  },
  {
    id: 'img3',
    url: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a',
    category: 'ceremony',
    albumId: 'album2'
  },
  {
    id: 'img4',
    url: 'https://images.unsplash.com/photo-1723832347953-83c28e2d4dd2',
    category: 'ceremony',
    albumId: 'album3'
  },
  {
    id: 'img5',
    url: 'https://images.unsplash.com/photo-1591604466107-ec97de577aff',
    category: 'couple',
    albumId: 'album4'
  },
  {
    id: 'img6',
    url: 'https://images.unsplash.com/photo-1507915977619-6ccfe8003ae6',
    category: 'ceremony',
    albumId: 'album5'
  },
  {
    id: 'img7',
    url: 'https://images.unsplash.com/photo-1527529482837-4698179dc6ce',
    category: 'candid',
    albumId: 'album6'
  },
  {
    id: 'img8',
    url: 'https://images.pexels.com/photos/34793910/pexels-photo-34793910.jpeg',
    category: 'couple',
    albumId: 'album7'
  },
  {
    id: 'img9',
    url: 'https://images.pexels.com/photos/14339090/pexels-photo-14339090.jpeg',
    category: 'portraits',
    albumId: 'album8'
  },
  {
    id: 'img10',
    url: 'https://images.unsplash.com/flagged/photo-1552981941-424aac2b4311',
    category: 'couple',
    albumId: 'album1'
  },
  {
    id: 'img11',
    url: 'https://images.unsplash.com/photo-1533091090875-1ff4acc497dd',
    category: 'details',
    albumId: 'album1'
  },
  {
    id: 'img12',
    url: 'https://images.unsplash.com/photo-1599462616558-2b75fd26a283',
    category: 'couple',
    albumId: 'album1'
  },
  {
    id: 'img13',
    url: 'https://images.unsplash.com/photo-1621801306185-8c0ccf9c8eb8',
    category: 'details',
    albumId: 'album1'
  },
  {
    id: 'img14',
    url: 'https://images.unsplash.com/photo-1630526720753-aa4e71acf67d',
    category: 'prewedding',
    albumId: 'album1'
  },
  {
    id: 'img15',
    url: 'https://images.pexels.com/photos/36154486/pexels-photo-36154486.jpeg',
    category: 'prewedding',
    albumId: 'album1'
  },
  {
    id: 'img16',
    url: 'https://images.unsplash.com/photo-1583939411023-14783179e581',
    category: 'candid',
    albumId: 'album2'
  },
  {
    id: 'img17',
    url: 'https://images.unsplash.com/photo-1647296020388-787fdae78e3c',
    category: 'details',
    albumId: 'album2'
  },
  {
    id: 'img18',
    url: 'https://images.unsplash.com/photo-1723832348105-2e69f948135a',
    category: 'ceremony',
    albumId: 'album2'
  },
  {
    id: 'img19',
    url: 'https://images.unsplash.com/photo-1714972383570-44ddc9738355',
    category: 'candid',
    albumId: 'album2'
  },
  {
    id: 'img20',
    url: 'https://images.unsplash.com/photo-1677691257001-8bfd91e288ff',
    category: 'portraits',
    albumId: 'album8'
  },
  {
    id: 'img21',
    url: 'https://images.unsplash.com/photo-1677691257237-3294c7fd18a5',
    category: 'portraits',
    albumId: 'album8'
  },
  {
    id: 'img22',
    url: 'https://images.unsplash.com/photo-1677691256999-45d69a11b197',
    category: 'portraits',
    albumId: 'album8'
  },
  {
    id: 'img23',
    url: 'https://images.unsplash.com/photo-1610173826014-d131b02d69ca',
    category: 'portraits',
    albumId: 'album8'
  },
  {
    id: 'img24',
    url: 'https://images.pexels.com/photos/14339118/pexels-photo-14339118.jpeg',
    category: 'portraits',
    albumId: 'album4'
  },
  {
    id: 'img25',
    url: 'https://images.pexels.com/photos/13152508/pexels-photo-13152508.jpeg',
    category: 'details',
    albumId: 'album1'
  },
  {
    id: 'img26',
    url: 'https://images.pexels.com/photos/13152507/pexels-photo-13152507.jpeg',
    category: 'details',
    albumId: 'album1'
  }
];

export const categories = [
  { id: 'all', name: 'All Photos', count: allGalleryImages.length },
  { id: 'prewedding', name: 'Pre-Wedding', count: allGalleryImages.filter(img => img.category === 'prewedding').length },
  { id: 'ceremony', name: 'Ceremony', count: allGalleryImages.filter(img => img.category === 'ceremony').length },
  { id: 'couple', name: 'Couple Shots', count: allGalleryImages.filter(img => img.category === 'couple').length },
  { id: 'candid', name: 'Candid', count: allGalleryImages.filter(img => img.category === 'candid').length },
  { id: 'portraits', name: 'Portraits', count: allGalleryImages.filter(img => img.category === 'portraits').length },
  { id: 'details', name: 'Details', count: allGalleryImages.filter(img => img.category === 'details').length }
];

// Testimonials
export const testimonials = [
  {
    id: 1,
    name: 'Sarah & Michael',
    event: 'Garden Wedding',
    rating: 5,
    text: 'Absolutely stunning work! Every moment was captured perfectly. The photos exceeded our expectations and we\'ll treasure them forever.',
    image: 'https://images.unsplash.com/photo-1573676048035-9c2a72b6a12a'
  },
  {
    id: 2,
    name: 'Emily & David',
    event: 'Beach Wedding',
    rating: 5,
    text: 'Professional, creative, and so easy to work with. The photos are breathtaking and captured the emotion of our day beautifully.',
    image: 'https://images.unsplash.com/photo-1583939003579-730e3918a45a'
  },
  {
    id: 3,
    name: 'Priya & Raj',
    event: 'Traditional Wedding',
    rating: 5,
    text: 'We couldn\'t be happier with our wedding photos! Every detail, every emotion was perfectly captured. Highly recommended!',
    image: 'https://images.unsplash.com/photo-1599462616558-2b75fd26a283'
  }
];

// Video Stories - Wedding Trailers and Reels (EASILY EDITABLE)
export const videoStories = [
  {
    id: 'video1',
    title: 'Romantic Garden Wedding',
    type: 'Wedding Trailer',
    thumbnail: 'https://images.unsplash.com/photo-1519741497674-611481863552',
    url: 'https://www.youtube.com/@sagrsen'
  },
  {
    id: 'video2',
    title: 'Traditional Ceremony',
    type: 'Wedding Film',
    thumbnail: 'https://images.unsplash.com/photo-1606216794074-735e91aa2c92',
    url: 'https://www.youtube.com/@sagrsen'
  },
  {
    id: 'video3',
    title: 'Candid Moments',
    type: 'Short Reel',
    thumbnail: 'https://images.unsplash.com/photo-1522413452208-996ff3f3e740',
    url: 'https://www.youtube.com/@sagrsen'
  },
  {
    id: 'video4',
    title: 'Pre-Wedding Story',
    type: 'Love Story',
    thumbnail: 'https://images.unsplash.com/photo-1623430011058-a06f4f6c4d1c',
    url: 'https://www.youtube.com/@sagrsen'
  },
  {
    id: 'video5',
    title: 'Destination Wedding',
    type: 'Wedding Trailer',
    thumbnail: 'https://images.unsplash.com/photo-1511285560929-80b456fea0bc',
    url: 'https://www.youtube.com/@sagrsen'
  },
  {
    id: 'video6',
    title: 'Reception Highlights',
    type: 'Short Reel',
    thumbnail: 'https://images.unsplash.com/photo-1478146896981-b80fe463b330',
    url: 'https://www.youtube.com/@sagrsen'
  }
];

